import { useDebounceFn } from 'ahooks';

export default function useDebounceHandler(option: { isDebounce: boolean; onHandler?: any }) {
  const { isDebounce = false, onHandler } = option || {};

  const { run: onHandlerDebounceRun } = useDebounceFn(
    (payload) => {
      onHandler?.(payload);
    },
    { wait: 300 },
  );

  const handler = (payload: any) => {
    if (isDebounce) {
      onHandlerDebounceRun(payload);
      return;
    }
    onHandler?.(payload);
  };

  return {
    handler,
  };
}
